(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["grid-laureats"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.categories-slider').slick({
      autoplay: true,
      autoplaySpeed: 1,
      infinite: true,
      speed: 5000,
      slidesToShow: 5,
      variableWidth: true,
      cssEase: 'linear',
      centerMode: true,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
    });

    $('.letter').hover(function(){
      $('#laureats-list .overlay').addClass('img-active').html('<img style="display: none;" src="'+ $('a', this).data('hover') +'"> <p class="name">'+ $('a', this).data('name') +', <br>'+ $('a', this).data('job') +'</p>');
      $('#laureats-list .overlay img').fadeIn(400);
    }, function(){
      //$('#laureats-list .overlay').removeClass('img-active');
    });
  
    $('.open-laureats-list').on('click', function(){
      $('#laureats-list .overlay').removeClass('img-active').html('&nbsp;');
    });
  
    var selectElem = document.querySelector('.facet-filters__sort');
    selectElem.addEventListener('change', function() {
      var collections = document.querySelectorAll('.collection-list');
      collections.forEach(collection => {
        collection.classList.remove('active');
      });
      if( selectElem.value == "title-ascending" ) {
        document.querySelector('.collection-list.title-ascending').classList.add('active');
      }
      else if( selectElem.value == "title-descending" ) {
        document.querySelector('.collection-list.title-descending').classList.add('active');
      }
      else if( selectElem.value == "price-recent" ) {
        document.querySelector('.collection-list.price-recent').classList.add('active');
      }
      else if( selectElem.value == "price-old" ) {
        document.querySelector('.collection-list.price-old').classList.add('active');
      }
    });

    $('#MainContent').on('click', '.facet-filters__field svg', function(){
      openSort();
    });

    $('#MainContent').on('click', '.facet-filters__field .facet-filters__label', function(){
      openSort();
    });

    $('#MainContent').on('change', '.facet-filters__sort', (event) => {
      openSort();
    });

    function openSort(){
      document.querySelector('.facet-filters__field').classList.toggle('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laureat-collection-product-grid"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('#MainContent').on('click', '.facet-filters__field svg', function(){
      openSort();
    });

    $('#MainContent').on('click', '.facet-filters__field .facet-filters__label', function(){
      openSort();
    });

    $('#MainContent').on('change', '.facet-filters__sort', (event) => {
      openSort();
    });

    function openSort(){
      document.querySelector('.facet-filters__field').classList.toggle('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  $(document).ready(function(){
    $('.categories-slider').slick({
      autoplay: true,
      autoplaySpeed: 1,
      infinite: true,
      speed: 5000,
      slidesToShow: 5,
      variableWidth: true,
      cssEase: 'linear',
      centerMode: true,
      arrows: false
    });

    $('.open-filters-materials').on('click', function(){
      $('.mobile-facets__disclosure').addClass('open menu-opening').attr('open', true);
      $('.mobile-facets__main.has-submenu').addClass('submenu-open');
      $('#Details-Mobile-1-template--15745830092970__product-grid').addClass('menu-opening').attr('open', '');
      $('Details-Mobile-1-template--15745830092970__product-grid .mobile-facets__summary').attr('aria-expanded', 'true');
    });

    $('.open-laureats-list').on('click', function(){
      $('.mobile-facets__disclosure').addClass('open menu-opening').attr('open', true);
      $('.mobile-facets__main.has-submenu').addClass('submenu-open');
      $('#Details-Mobile-2-template--15745830092970__product-grid').addClass('menu-opening').attr('open', '');
      $('Details-Mobile-2-template--15745830092970__product-grid .mobile-facets__summary').attr('aria-expanded', 'true');
    });

    $('#main-collection-filters').on('click', '.facet-filters__field svg', function(){
      openSort();
    });

    $('#main-collection-filters').on('click', '.facet-filters__field .facet-filters__label', function(){
      openSort();
    });

    $('#main-collection-filters').on('change', '.facet-filters__sort', (event) => {
      openSort();
    });

    function openSort(){
      document.querySelector('.facet-filters__field').classList.toggle('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  $(document).ready(function(){
    $('.categories-slider').slick({
      autoplay: true,
      autoplaySpeed: 1,
      infinite: true,
      speed: 5000,
      slidesToShow: 5,
      variableWidth: true,
      cssEase: 'linear',
      centerMode: true,
      arrows: false
    });
  });

  $('.letter').hover(function(){
    $('.popin-right .overlay').addClass('img-active').html('<img style="display: none;" src="'+ $('a', this).data('hover') +'"> <p class="name">'+ $('a', this).text() +', <br>'+ $('a', this).data('tags') +'</p>');
    $('.popin-right .overlay img').fadeIn(400);
  }, function(){
    $('.popin-right .overlay').removeClass('img-active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-categories-slider"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.categories-slider').slick({
      autoplay: true,
      autoplaySpeed: 1,
      infinite: true,
      speed: 5000,
      slidesToShow: 5,
      variableWidth: true,
      cssEase: 'linear',
      centerMode: true,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            pauseOnFocus: false,
            pauseOnHover: false,
            swipe: false
          }
        },
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-laureat-collection"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.slider-products').slick({
      autoplay: true,
      slidesToShow: 3,
      arrows: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '40px',
          }
        },
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-list-artisans-home"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.first-slider').slick({
      autoplay: true,
      autoplaySpeed: 1,
      infinite: true,
      speed: 5000,
      slidesToShow: 4,
      cssEase: 'linear',
      centerMode: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      arrows: false,
      prevArrow: '<div class="container" style="position: relative;"><button class="slick-prev slick-arrow" type="button"></button><button class="slick-next slick-arrow" type="button"></button></div>',
      nextArrow: '',
      draggable: false,
      swipe: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            swipe: false
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            swipe: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            swipe: false
          }
        },
      ]
    });

    $('.second-slider').slick({
      autoplay: true,
      autoplaySpeed: 1,
      infinite: true,
      speed: 5000,
      slidesToShow: 4,
      initialSlide: 6,
      cssEase: 'linear',
      centerMode: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      arrows: false,
      rtl: true,
      draggable: false,
      swipe: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            swipe: false
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            swipe: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            swipe: false
          }
        },
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-others"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.others-slider').slick({
      autoplay: false,
      infinite: true,
      slidesToShow: 4,
      centerMode: true,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" type="button"></button>',
      nextArrow: '<button class="slick-next slick-arrow" type="button"></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            arrows: false,
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            arrows: false,
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            arrows: false,
          }
        },
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-similar-products"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.similar-products-grid').slick({
      autoplay: false,
      slidesToShow: 3,
      arrows: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '40px',
          }
        },
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

})();
